import React from 'react';
import './style.scss';
import Dialog from '../../../components/general/dialog';
import Button from '../../../components/controls/button';
import LoadableImage from '../../../components/general/loadableImage';

const InstallMetamaskDialog = ({ opened, onClose }) => {
  const openMetamask = () => {
    onClose();
    window.open(process.env.REACT_APP_METAMASK_DEEPLINK);
  };

  return (
    <Dialog
      opened={opened}
      onClose={onClose}
      maxWidth='sm'
      className='install-mm-dialog'
      noCloseOnMobile
    >
      <h4 className='install-mm-dialog-header'>
        In order to play the game and own NFT, you need MetaMask wallet
      </h4>
      <LoadableImage
        src={'/assets/images/common/metamask.png'}
        className='install-mm-dialog-image'
      />
      {/*<p className='install-mm-dialog-description'>
        To open/install metamask and {doWhat}, please, click a button below
      </p>*/}
      <Button onClick={openMetamask}>Open/Install Metamask</Button>
    </Dialog>
  );
};

export default InstallMetamaskDialog;
